import React from 'react';
import { render } from 'react-dom';
import { RouterProvider } from "react-router-dom";
import { router } from "./router";
import "./index.css"
import IntlProviderWrapper from './IntlProviderWrapper';

render(
    <React.StrictMode>
        <IntlProviderWrapper>
            <div className="app-container">
                <div className="main-container">
                    <RouterProvider router={router} />
                </div>
            </div>
        </IntlProviderWrapper>
    </React.StrictMode>,
    document.getElementById('root')
);